// Largest chat request body the API accepts — matches nginx's `client_max_body_size` in
// infrastructure/deployment/nginx/*.conf. Larger requests are rejected with a 413 that the
// browser surfaces as a bare "Network Error" (the response carries no CORS headers).
export const MAX_REQUEST_BYTES = 20 * 1024 * 1024;

// Keep in sync with backend/apps/rag/services/attachments.py.
export const REPORT_TOO_LARGE_ANSWER =
  'This report has too much data to analyze at once. Use the report options to narrow it down, for example to fewer locations or a shorter date range, then try again.';
export const ATTACHMENTS_TOO_LARGE_ANSWER =
  'Your attachments are too large to process together. Try again with fewer or smaller files.';
export const REQUEST_TOO_LARGE_ANSWER =
  'This request is too large. Try fewer or smaller attachments, narrow your report using the report options, or start a new conversation.';

export type TooLargeAnswer =
  | typeof REPORT_TOO_LARGE_ANSWER
  | typeof ATTACHMENTS_TOO_LARGE_ANSWER
  | typeof REQUEST_TOO_LARGE_ANSWER;

interface TooLargeRequestContents {
  hasAttachments: boolean;
  hasReport: boolean;
}

// Thrown when the chat request is too large to send; its message is the user-facing answer.
export class RequestTooLargeError extends Error {
  constructor(message: TooLargeAnswer) {
    super(message);
    this.name = 'RequestTooLargeError';
  }
}

export function getRequestBytes(payload: unknown): number {
  return new Blob([JSON.stringify(payload)]).size;
}

export function tooLargeAnswer({ hasAttachments, hasReport }: TooLargeRequestContents): TooLargeAnswer {
  if (hasReport && !hasAttachments) return REPORT_TOO_LARGE_ANSWER;
  if (hasAttachments && !hasReport) return ATTACHMENTS_TOO_LARGE_ANSWER;
  return REQUEST_TOO_LARGE_ANSWER;
}
